module.exports = __webpack_public_path__ + "img/IMG_5898.88ebc39a.jpg";